var map = {
	"./template.bet575": 1625,
	"./template.bet575.tsx": 1625,
	"./template.bet777": 1626,
	"./template.bet777.tsx": 1626,
	"./template.betprofessor": 1627,
	"./template.betprofessor.tsx": 1627,
	"./template.betroyale": 1628,
	"./template.betroyale.tsx": 1628,
	"./template.buffalobet": 1629,
	"./template.buffalobet.tsx": 1629,
	"./template.chromabet": 1630,
	"./template.chromabet.tsx": 1630,
	"./template.default": 673,
	"./template.default.tsx": 673,
	"./template.fiestabet": 1631,
	"./template.fiestabet.tsx": 1631,
	"./template.gigabet": 1632,
	"./template.gigabet.tsx": 1632,
	"./template.goldenbet888": 1633,
	"./template.goldenbet888.tsx": 1633,
	"./template.goldenrush": 1634,
	"./template.goldenrush.tsx": 1634,
	"./template.hyperbet": 1635,
	"./template.hyperbet.tsx": 1635,
	"./template.juicybet": 1636,
	"./template.juicybet.tsx": 1636,
	"./template.junglebet": 1637,
	"./template.junglebet.tsx": 1637,
	"./template.magnumbet": 1638,
	"./template.magnumbet.tsx": 1638,
	"./template.oldgill": 1639,
	"./template.oldgill.tsx": 1639,
	"./template.puntcity": 1640,
	"./template.puntcity.tsx": 1640,
	"./template.puntgenie": 1641,
	"./template.puntgenie.tsx": 1641,
	"./template.pyramidbet": 1642,
	"./template.pyramidbet.tsx": 1642,
	"./template.questbet": 1643,
	"./template.questbet.tsx": 1643,
	"./template.slambet": 1644,
	"./template.slambet.tsx": 1644,
	"./template.sterlingparker": 1645,
	"./template.sterlingparker.tsx": 1645,
	"./template.sugarcastle": 1646,
	"./template.sugarcastle.tsx": 1646,
	"./template.templebet": 1647,
	"./template.templebet.tsx": 1647,
	"./template.titanbet": 1648,
	"./template.titanbet.tsx": 1648,
	"./template.ts": 987,
	"./template.vikingbet": 1649,
	"./template.vikingbet.tsx": 1649,
	"./template.volcanobet": 1650,
	"./template.volcanobet.tsx": 1650,
	"./template.wellbet": 1651,
	"./template.wellbet.tsx": 1651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2461;